import { render, staticRenderFns } from "./bankNameField.vue?vue&type=template&id=15d2b445&scoped=true"
import script from "./bankNameField.vue?vue&type=script&lang=js"
export * from "./bankNameField.vue?vue&type=script&lang=js"
import style0 from "./bankNameField.vue?vue&type=style&index=0&id=15d2b445&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d2b445",
  null
  
)

export default component.exports